<template>
  <div>
    <v-dialog
      persistent
      width="400px"
      v-model="showModal"
    >
      <v-card class="pa-2" v-if="showModal">
        <div class="d-flex flex-column mx-6 my-4">
          <p class="mb-1">
            {{ message }}
          </p>
          <v-progress-linear
            rounded
            indeterminate
            color="primary"
            height="8"
          />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'LoadingModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: "Loading, please wait"
    }
  },
  watch: {
    showModal(newVal) {
      if (newVal) {
        this.changes = null;
        this.internalSrc = this.src;
      }
    },
    src() {
      this.internalSrc = this.src;
    }
  },
}
</script>
